import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row
} from "../../components/Component";
import { getConfig } from "../../config";
import { GET, POST } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { TAX_DETAIL_KEY, TAX_DETAIL_KEY_NAME, TAX_KEY, TAX_KEY_NAME } from "../../utils/Utils";
const config = getConfig();


const DEFAULT_UPSERT_DETAIL = {
  value: 0,
};

const TaxReport = () => {
  const historyDom = useHistory();
  const printRef = useRef();
  const [smOption, setSmOption] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [timeNow, setTimeNow] = useState();
  const [view, setView] = useState({
    addReport: false,
    upsertDetail: false,
  });
  const [upsertDetailData, setUpsertDetailData] = useState();
  const [filter, setFilter] = useState({
    monthYear: searchParams.get("monthYear") || moment().format("YYYY-MM"),
  });
  const [summary, setSummary] = useState({
    total: 0,
  });
  const [data, setData] = useState();
  const [dataDetail, setDataDetail] = useState();
  const [confirmed, setConfirmed] = useState(false);

  const methodForm = useForm({
    defaultValues: {
      ...DEFAULT_UPSERT_DETAIL,
    },
  });
  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    watch,
    setValue,
  } = methodForm;

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  useEffect(() => {
    const newParams = new URLSearchParams({
      monthYear: filter.monthYear,
    });
    historyDom.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    GET(
      `/tax/report-tax`,
      {
        monthYear: filter.monthYear,
      },
      true
    ).then((resp) => {
      const { summary, confirmed, data, dataDetail } = resp.data;
      setSummary(summary);
      setData(data);
      setDataDetail(dataDetail);
      setConfirmed(confirmed);
    });
  }, [filter, timeNow]);

  const exportExcel = () => {
    const params = new URLSearchParams({
      monthYear: filter.monthYear,
      token: getToken(),
    });
    const url = `${process.env.REACT_APP_API_URL
      }/api/v1/tax/report-tax-excel?${params.toString()}`;
    window.open(url, "_blank");
  };

  const onFormCancel = () => {
    reset({
      ...DEFAULT_UPSERT_DETAIL,
    });
    setUpsertDetailData();
    setView({ addReport: false, upsertDetail: false });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  const addReport = () => {
    POST(
      `/tax/confirm-report-tax`,
      {},
      {
        monthYear: filter.monthYear,
      },
      true
    )
      .then(() => {
        toast.success("Xác nhận thuế thành công");
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        resetData();
      });
  };

  // Submits form data
  const onHandleSubmit = () => {
    const { value } = getValues();

    const formData = {
      value,
      monthYear: filter.monthYear,
      key: upsertDetailData.key,
    };

    POST("/tax/upsert-detail", formData, {}, true)
      .then((res) => {
        toast.success("Cập nhật thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };
  return (
    <React.Fragment>
      <Head title="Báo cáo thuế"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo thuế</BlockTitle>
            </BlockHeadContent>
            <div className="toggle-wrap nk-block-tools-toggle">
              <a
                href="#more"
                className="btn btn-icon btn-trigger toggle-expand mr-n1"
                onClick={(ev) => {
                  ev.preventDefault();
                  setSmOption(!smOption);
                }}
              >
                <Icon name="more-v"></Icon>
              </a>
              <div
                className="toggle-expand-content"
                style={{ display: smOption ? "block" : "none" }}
              >
                <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                  <li>
                    <div className="form-group">
                      <div className="form-control-wrap">
                        <input
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: moment(e.target.value).format(
                                "YYYY-MM"
                              ),
                            })
                          }
                          placeholder="Lọc theo ngày"
                          value={filter.monthYear}
                          type="month"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </li>
                  {data ? (
                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>
                        {!confirmed ? (
                          <>
                            <Button
                              onClick={() => toggle("addReport")}
                              className="ml-3"
                            >
                              Xác nhận
                            </Button>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </li>
                  ) : (
                    <></>
                  )}
                </ul>
              </div>
            </div>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div
            id="DataTables_Table_1_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
          >
            <div className="row justify-between g-2">
              <div className="col-8 col-sm-6 text-start"></div>
              <div className="col-5 col-sm-6 text-end">
                <div className="datatable-filter">
                  <div className="d-flex justify-content-end g-2">
                    <div
                      className="dataTables_length"
                      id="DataTables_Table_1_length"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <Row>
                {data ? (
                  <Col md={6} className={'border-0'}>
                    <table
                      className="table-bordered w-100 table table-responsive"
                      ref={printRef}
                    >
                      <tbody>
                        <tr style={{ backgroundColor: "#91d14f" }}>
                          <td style={{ textAlign: "center" }} colSpan={12}>
                            BẢNG THEO DÕI TỔNG HỢP THUẾ {filter.monthYear}
                          </td>
                        </tr>
                        <tr style={{ backgroundColor: "#feff98" }}>
                          <th>Loại</th>
                          <th>Số tiền(đ)</th>
                        </tr>
                        {Object.values(TAX_KEY).map((key) => {
                          const allowEdit = key === "REFUND";
                          return (
                            <tr
                              style={{
                                backgroundColor:
                                  key === TAX_KEY.SUMMARY
                                    ? "#91d14f"
                                    : "white",
                              }}
                              key={key}
                            >
                              <td>{TAX_KEY_NAME[key]}</td>
                              <td>
                                <div className="d-flex w-100 justify-content-end">
                                  {!confirmed && allowEdit ? (
                                    <Button
                                      onClick={() => {
                                        setUpsertDetailData({
                                          key,
                                        });
                                        toggle("upsertDetail");
                                        reset({
                                          value: data[key] || 0,
                                        });
                                      }}
                                      className="btn btn-sm btn-outline-primary btn-white mr-auto"
                                    >
                                      <Icon name={"edit"}></Icon>
                                    </Button>
                                  ) : (
                                    <></>
                                  )}
                                  <NumericFormat
                                    value={data[key] || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                    className="mr-1"
                                  />

                                </div>
                              </td>
                            </tr>
                          );
                        })}
                        <tr
                          style={{
                            backgroundColor: "#feff98",
                          }}
                        >
                          <td>Tổng cộng</td>
                          <td className=" text-right">
                            <NumericFormat
                              className="mr-1"
                              value={summary.total}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                              displayType="text"
                            />
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </Col>
                ) : (
                  ""
                )}

                <Col md={6}>
                  <table
                    className="table-bordered w-100 table table-responsive"
                    ref={printRef}
                  >
                    <tbody>
                      <tr style={{ backgroundColor: "#91d14f" }}>
                        <td style={{ textAlign: "center" }} colSpan={12}>
                          BẢNG THEO DÕI HOÀN THUẾ {filter.monthYear}
                        </td>
                      </tr>
                      <tr style={{ backgroundColor: "#feff98" }}>
                        <th>Loại</th>
                        <th>Xuất khẩu</th>
                        <th>Trong nước</th>
                        <th>Tổng cộng</th>
                      </tr>
                      {Object.values(TAX_DETAIL_KEY).map((key) => {
                        const internalValue = dataDetail?.INTERNAL[key];
                        const externalValue = dataDetail?.EXTERNAL[key];
                        const totalValue = dataDetail?.TOTAL[key];
                        const allowEdit = {
                          INTERNAL: ['REFUND', 'LAST_LESS_TAX'],
                          EXTERNAL: ['REFUND'],
                          TOTAL: [],
                        };
                        return (
                          <tr
                            style={{
                              backgroundColor:
                                key === TAX_DETAIL_KEY.SUMMARY
                                  ? "#91d14f"
                                  : "white",
                            }}
                            key={key}
                          >
                            <td>{TAX_DETAIL_KEY_NAME[key]}</td>

                            <td>
                              <div className="d-flex w-100 justify-content-end">
                                {allowEdit.EXTERNAL.includes(key) ? (
                                  <Button
                                    onClick={() => {
                                      setUpsertDetailData({
                                        key: `${key}_DETAIL_EXTERNAL`,

                                      });
                                      toggle("upsertDetail");
                                      reset({
                                        value: externalValue || 0,
                                      });
                                    }}
                                    className="btn btn-sm btn-outline-primary btn-white mr-auto"
                                  >
                                    <Icon name={"edit"}></Icon>
                                  </Button>
                                ) : (
                                  <></>
                                )}
                                <NumericFormat
                                  className="mr-1"
                                  value={externalValue || 0}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={TAX_DETAIL_KEY.PERCENT_SELL_OUT === key ? 4 : 0}
                                  displayType="text"
                                />

                              </div>
                            </td>
                            <td>
                              <div className="d-flex w-100 justify-content-end">
                                {allowEdit.INTERNAL.includes(key) ? (
                                  <Button
                                    onClick={() => {
                                      setUpsertDetailData({
                                        key: `${key}_DETAIL_INTERNAL`,
                                      });
                                      toggle("upsertDetail");
                                      reset({
                                        value: internalValue || 0,
                                      });
                                    }}
                                    className="btn btn-sm btn-outline-primary btn-white mr-auto"
                                  >
                                    <Icon name={"edit"}></Icon>
                                  </Button>
                                ) : (
                                  <></>
                                )}
                                <NumericFormat
                                  value={internalValue || 0}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={TAX_DETAIL_KEY.PERCENT_SELL_OUT === key ? 4 : 0}
                                  displayType="text"
                                  className="mr-1"
                                />

                              </div>
                            </td>
                            <td>
                              <div className="d-flex w-100 justify-content-end">
                                {allowEdit.TOTAL.includes(key) ? (
                                  <Button
                                    onClick={() => {
                                      setUpsertDetailData({
                                        key: `${key}_DETAIL_TOTAL`,
                                      });
                                      toggle("upsertDetail");
                                      reset({
                                        value: totalValue || 0,
                                      });
                                    }}
                                    className="btn btn-sm btn-outline-primary btn-white mr-auto"
                                  >
                                    <Icon name={"edit"}></Icon>
                                  </Button>
                                ) : (
                                  <></>
                                )}
                                <NumericFormat
                                  className="mr-1"
                                  value={totalValue || 0}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={TAX_DETAIL_KEY.PERCENT_SELL_OUT === key ? 4 : 0}
                                  displayType="text"
                                />

                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Col>

              </Row>
            </div>
          </div>
        </Block>
        <Modal isOpen={view.addReport} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn gửi báo cáo các đơn đã duyệt trong khoảng thời
                gian này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    addReport();
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={view.upsertDetail}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Cập nhật tiền</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" >
                          Số tiền(đ)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="value"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="value"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>Cập nhật</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default TaxReport;
